import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default class extends Controller {
  static targets = [
    "addButton",
    "submitButton",
    "input",
    "feedback",
    "userFeedback",
  ];

  rotate() {
    this.addButtonTarget.classList.remove("rotate-45");
  }

  checkSiret(event) {
    const input = event.currentTarget;
    if (!input) return false;

    $.get(`/check_siret/${input.value}.json`)
      .done((results) => {
        if (results.enterprise) {
          input.classList.add("is-invalid");
          this.element.insertAdjacentHTML(
            "afterbegin",
            `
          <div class="invalid-feedback d-flex" data-target="validation-new-ee.feedback">
            ${results.html}
          </div>
        `
          );
          this.addButtonTarget.disabled = true;
        } else {
          if (this.hasFeedbackTarget) {
            this.feedbackTarget.remove();
          }
          this.enableSubmitIfAllInputFilled();
          input.classList.remove("is-invalid");
        }
      })
      .fail((err) => console.log(err));
  }

  checkEmailREE(event) {
    const input = event.currentTarget;
    if (!input) return false;

    const data = new FormData();
    data.append("email", input.value);

    Rails.ajax({
      type: "post",
      url: `/check_email`,
      data: data,
      success: (results) => {
        if (results && !this.hasUserFeedbackTarget) {
          input.classList.add("is-invalid");
          input.insertAdjacentHTML(
            "afterend",
            `
          <div class="invalid-feedback" data-target="validation-new-ee.userFeedback">
            <p>Un utilisateur est déjà enregistré avec cet email. Merci de contacter cette personne avant de continuer.</p>
          </div>
          `
          );
          this.addButtonTarget.disabled = true;
        } else {
          if (!results && this.hasUserFeedbackTarget) {
            this.userFeedbackTarget.remove();
          }
          this.enableSubmitIfAllInputFilled();
          input.classList.remove("is-invalid");
        }
      },
    });
  }

  enableSubmitIfAllInputFilled = () => {
    if (this.inputTargets.every((target) => target.value !== "")) {
      this.addButtonTarget.disabled = false;
    } else {
      this.addButtonTarget.disabled = true;
    }
  };
}
